var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeline-block",class:{ 'timeline-inverted': _vm.inverted }},[_vm._t("badge",function(){return [_c('span',{staticClass:"timeline-step",class:`badge-${_vm.badgeType}`},[_c('i',{class:_vm.badgeIcon})])]}),_c('div',{staticClass:"timeline-content"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }